
define('text!Magento_Checkout/template/minicart/item/price.html',[],function () { return '<!--\n/**\n * Copyright © Magento, Inc. All rights reserved.\n * See COPYING.txt for license details.\n */\n-->\n<div class="price-container">\n  <span class="price-wrapper" data-bind="html: price"></span>\n</div>\n';});

